import axios from 'axios'
import store from '@/store'
import router from '@/router/routes'
import { debounce } from 'lodash-es'
import toast from '@/plugins/izitoast';

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_HOST_V2,
    headers: {
        common: {
            'Accept': 'application/json'
        }
    }
})

instance.interceptors.response.use(response => {
    return response
}, error => {
    switch (error.response.status) {
        case 401:
            window.oidc.userManager.signoutRedirect()
            break
        default:
            break
    }

    return Promise.reject(error)
})

export default instance
